const addBuildId = (url: string) => {
  const buildId = process.env.buildId;

  return `${url}${buildId ? `?${encodeURIComponent(buildId)}` : ''}`;
};

export const publicPath = (path: string) => {
  return addBuildId(`${process.env.publicPrefix}${path}`);
};

export const parseYearMonthParam = (
  value: string | string[] | undefined,
): { year: number; month: number } | null => {
  if (!value || typeof value !== 'string') return null;

  const match = value.match(/^(\d{4})-(\d{1,2})$/);
  if (!match) return null;

  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  if (month < 1 || month > 12) return null;

  return { year, month };
};
